import BaseConfig from './base';

let fundebugConfig: FundebugConfigs = {
    initConfig: {
        appversion: BaseConfig.version,
        silentConsole: true,
        silentVideo: false,
        apikey: '48a40f0e625f83f64f76813797323ea19d4251cfa3e87968d2a657fe672a4829',
        filters: [
            {
                url: /teststatic.dmall.com\/kayak-project\/shelvesbuild_refactoring\/dist\/index.umd.js/
            },
            {
                url: /static.dmall.com\/kayak-project\/shelvesbuild_refactoring\/dist\/index.umd.js/
            },
            {
                url: /devstatic.dmall.com\/kayak-project\/shelvesbuild_refactoring\/dist\/index.umd.js/
            },
            {
                message: /^Script error\.$/
            },
            {
                req: {
                    method: /^GET$/
                }
            },
            {
                target: {
                    tagName: /^IMG$/
                }
            }
        ]
    }
};

export default fundebugConfig;
